import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import OnboardingGate from "@/components/OnboardingGate";

export function Protected({ children, adminOnly = false, requireOnboarded = true }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#05050A] text-white">
        <div className="font-mono text-sm opacity-70">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (requireOnboarded) return <OnboardingGate>{children}</OnboardingGate>;
  return children;
}
